<template>
  <ix-router-link class="tag" :to="gallery.url" v-on:click.native="$event.stopImmediatePropagation();handleNav()">{{ gallery.name }}</ix-router-link>
</template>

<script>
export default {
  props: {
    galleryId: {
      type: String,
      default: '0'
    },
    url: String
  },
  data: function () {
    return {
      gallery: { url: '/styles'}
    }
  },
  created: function () {
    if(this.galleryId || this.url) {
      this.loadData()
    }
  },
  methods: {
    loadData: async function () {
      await this.$store.dispatch('fetchGalleries')
      let res = 0
      if(this.url) {
        let curl = this.$k.cleanGalleryName(this.url)
        res = this.$store.state.galleries.find(el => { return el.url.endsWith(curl)})
      }
      else if(this.galleryId) {
        res = this.$store.getters.gallery(Number(this.galleryId))
      }
      
      if(res) {
        this.gallery = res
      }
      
    },
    handleNav() {
      this.$emit('closing')
    }
  },
  watch: {
    galleryId: function () {
      if(this.galleryId){
        this.loadData()
      }
      
    },
    url: function () {
      if(this.url) {
        
        this.loadData()
      }
    }
  }
}
</script>

